import React from 'react';
import { select as selectStyle } from './trackUi';

export default function StatusBadge({ status, small }) {
  if (!status) return null;
  return (
    <span
      style={{
        display: 'inline-block',
        padding: small ? '1px 6px' : '2px 8px',
        borderRadius: 999,
        fontSize: small ? 11 : 12,
        fontWeight: 700,
        color: '#fff',
        background: status.color || '#6b7280',
        whiteSpace: 'nowrap',
      }}
    >
      {status.label}
    </span>
  );
}

export function StatusSelect({ statuses, value, onChange, style }) {
  const cur = (statuses || []).find((s) => s.key === value);
  return (
    <select
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      onClick={(e) => e.stopPropagation()}
      style={{
        ...selectStyle,
        minWidth: 84,
        fontWeight: 700,
        color: cur?.color || '#1f2937',
        borderColor: cur?.color || '#ccc',
        ...style,
      }}
    >
      {!cur && value ? <option value={value}>{value}</option> : null}
      {(statuses || []).map((s) => (
        <option key={s.key} value={s.key}>{s.label}</option>
      ))}
    </select>
  );
}
